import Vue from 'vue';
import VueRouter from 'vue-router';
import http from './http'

const Login = () => import("@/views/login.vue");

import Cookies from 'js-cookie'

Vue.use(VueRouter);

import PcHeader from '../components/pcHeader.vue'
import H5Header from '../components/h5Header.vue'

let pageUrl = PcHeader
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {

	pageUrl = H5Header
	//说明是移动端
} else {

	pageUrl = PcHeader
	//说明是pc端
}
// 不需要路由验证页面
const whiteList = ['amazonCallBack']
const routes = [{
		path: '/',
		redirect: '/login',
		// redirect: 'Login',
	},
	{
		path: '/login',
		name: 'Login',
		beforeEnter(from, to, next) {
			if (!Cookies.get('token')) {

				if (whiteList.indexOf(to.name) !== -1) {
					// 在免登录白名单中，直接进入
					next('/amazonCallBack')
					return;
				}
			}
			next();
		},
		component: Login,
		meta: {
			keepAlive: true
		}
		// component: () => import('')

	},
	{
		path: '/iDssS/login/:path',
		name: 'iDssSLogin',
		beforeEnter(from) {
			let code = null;
			let state = null;
			const url = document.location.toString();
			const arrObj = url.split("?");
			if (arrObj.length > 1) {
				const arrPara = arrObj[1].split("&");
				let arr;
				for (var i = 0; i < arrPara.length; i++) {

					arr = arrPara[i].split("=");
					if (arr != null && arr[0] == "code") {

						code = arr[1];
					}
					if (arr != null && arr[0] == "state") {

						state = arr[1];
					}
				}
			}
			http.get("/iDssS/authLogin/" + from.params.path + "?code=" + code + "&state=" + state)
				.then((res) => {
					router.push({
						name: 'Login',
						params: {
							iDssSLoginData: res.data
						}
					})
				})
		},
		component: Login,
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/forgetPas',
		name: 'ForgetPas',
		component: () => import('../views/forgetPas.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/register/:path',
		name: 'Register',
		component: () => import('../views/register.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('../views/register.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/reSuccessful',
		name: 'ReSuccessful',
		component: () => import('../views/success.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/showRes',
		name: 'ShowRes',
		component: () => import('../views/showResertPassword.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/amazonCallBack',
		name: 'amazonCallBack',
		component: () => import('../views/amazonCallBack.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/lazadaCallBack',
		name: 'lazadaCallBack',
		component: () => import('../views/lazadaCallBack.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/shopeeCallBack',
		name: 'shopeeCallBack',
		component: () => import('../views/shopeeCallBack.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/tiktokCallBack',
		name: 'tiktokCallBack',
		component: () => import('../views/tiktokCallBack.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/loanHtml',
		name: 'loanHtml',
		component: () => import('../views/loan/loanHtml.vue'),
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/loadPage',
		name: 'loadPage',
		component: () => import('../views/loadPage.vue'),
		meta: {
			keepAlive: true
		}
	},

	{
		path: '/home',
		beforeEnter(from, to, next) {

			if (!Cookies.get('token')) {
				if (whiteList.indexOf(to.name) !== -1) {
					// 在免登录白名单中，直接进入
					next()
				} else {
					// 没有访问权限的其他页将重定向到登录页。
					next('/login')
				}
				return;
			}
			next();
		},
		name: 'Home',
		component: pageUrl,
		meta: {
			keepAlive: true
		},
		redirect: to => {

			if (JSON.parse(sessionStorage.getItem('data')).length > 0) {
				let rous = JSON.parse(sessionStorage.getItem('data'))
				return {
					path: rous[0].titleEn
				}
			}
		},
		children: [{
				path: '/backstage',
				name: 'backstage',
				component: () => import('../views/routine/backstage.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/loginrealName',
				name:'loginrealName',
				component: () => import('../views/loginrealName.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/addShopAccount',
				name:'addShopAccount',
				component: () => import('../views/shopManag/addShopAccount.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/gengduo',
				name:'gengduo',
				component: () => import('../views/routine/gengduo.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shouquan',
				name:'shouquan',
				component: () => import('../views/problem/shouquan.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/globalOrder',
				name:'globalOrder',
				component: () => import('../views/globals/globalOrder.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/rateQuery',
				name:'rateQuery',
				component: () => import('../views/rate/rateQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/modifyPersonalPass',
				name:'modifyPersonalPass',
				component: () => import('../views/system/modifyPersonalPass.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/globalRemittance',
				name: 'globalRemittance',
				component: () => import('../views/globals/globalRemittance.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopApply',
				name:'shopApply',
				component: () => import('../views/shopManag/shopApply.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/setStop',
				name:'setStop',
				component: () => import('../views/shopManag/setStop.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopOrder',
				name:'shopOrder',
				component: () => import('../views/shopManag/shopOrder.vue'),
				meta: {
					keepAlive: true
				}
			},

			{
				path: '/shopQuery',
				name: 'shopQuery',
				component: () => import('../views/shopManag/shopQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopRent',
				name:'shopRent',
				component: () => import('../views/shopManag/shopRent.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopRentList',
				name:'shopRentList',
				component: () => import('../views/shopManag/shopRentList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopRentTwo',
				name:'shopRentTwo',
				component: () => import('../views/shopManag/shopRentTwo.vue'),
				meta: {
					keepAlive: true
				}
			},

			// {
			// 	path: '/supplementShopInfo',
			// 	name:'supplementShopInfo',
			// 	component: () => import('../views/shopManag/supplementShopInfo.vue'),
			// 	meta: {
			// 		keepAlive: true
			// 	}
			// },
			{
				path: '/shopSettlement',
				name:'shopSettlement',
				component: () => import('../views/shopManag/shopSettlement.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopAccountDetail',
				name:'shopAccountDetail',
				component: () => import('../views/shopManag/shopAccountDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopAuthDetail',
				name:'shopAuthDetail',
				component: () => import('../views/shopManag/shopAuthDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/holderManage',
				name:'holderManage',
				component: () => import('../views/shopManag/holderManage.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/holderAddCompany',
				name:'holderAddCompany',
				component: () => import('../views/shopManag/holderAddCompany.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/holderAddLegal',
				name:'holderAddLegal',
				component: () => import('../views/shopManag/holderAddLegal.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/businessInformation',
				name:'businessInformation',
				component: () => import('../views/shopManag/businessInformation.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/holderAddShareHolders',
				name:'holderAddShareHolders',
				component: () => import('../views/shopManag/holderAddShareHolders.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/holderDetail',
				name:'holderDetail',
				component: () => import('../views/shopManag/holderDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/holderDetailRpp',
				name:'holderDetailRpp',
				component: () => import('../views/shopManag/holderDetailRpp.vue'),
				meta: {
					keepAlive: true
				}
			},

			{
				path: '/merchants',
				name:'merchants',
				component: () => import('../views/problem/merchants.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/merchSubmit',
				name:'merchSubmit',
				component: () => import('../views/problem/merchSubmit.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/accList',
				name:'accList',
				component: () => import('../views/system/accList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/accListCopy',
				name:'accListCopy',
				component: () => import('../views/system/accListCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/privateAcclist',
				name:'privateAcclist',
				component: () => import('../views/system/privateAcclist.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/privateAcclistCopy',
				name:'privateAcclistCopy',
				component: () => import('../views/system/privateAcclistCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/lookdetails',
				name:'lookdetails',
				component: () => import('../views/xiang/lookdetails.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/lookdetailsCopy',
				name:'lookdetailsCopy',
				component: () => import('../views/xiang/lookdetailsCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/lookdetails_fu',
				name:'lookdetails_fu',
				component: () => import('../views/xiang/lookdetails_fu.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/lookdetails_fuCopy',
				name:'lookdetails_fuCopy',
				component: () => import('../views/xiang/lookdetails_fuCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/unusual',
				name:'unusual',
				component: () => import('../views/xiang/unusual.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/lookdetailsTwo',
				name:'lookdetailsTwo',
				component: () => import('../views/xiang/lookdetailsTwo.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/lookdetailsTwoCopy',
				name:'lookdetailsTwoCopy',
				component: () => import('../views/xiang/lookdetailsTwoCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/account',
				name:'account',
				component: () => import('../views/accounts/account.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/accountList',
				name:'accountList',
				component: () => import('../views/accounts/accountList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/recharge',
				name:'recharge',
				component: () => import('../views/recharges/recharge.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/rechargeRecord',
				name:'rechargeRecord',
				component: () => import('../views/recharges/rechargeRecord.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remit',
				name:'remit',
				component: () => import('../views/Exchange/remit'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remitList',
				name:'remitList',
				component: () => import('../views/Exchange/remitList'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/customs',
				name:'customs',
				component: () => import('../views/report/customs.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/transferAccounts',
				name:'transferAccounts',
				component: () => import('../views/report/transferAccounts.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/transferAccList',
				name:'transferAccList',
				component: () => import('../views/report/transferAccList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/withdrawal',
				name:'withdrawal',
				component: () => import('../views/report/withdrawal.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/withdrawalTwoSets',
				name:'withdrawalTwoSets',
				component: () => import('../views/report/withdrawalTwoSets.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/withdrawalList',
				name:'withdrawalList',
				component: () => import('../views/report/withdrawalList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/TransferList',
				name:'TransferList',
				component: () => import('../views/transfer/TransferList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/withdrawalListTwoSets',
				name:'withdrawalListTwoSets',
				component: () => import('../views/report/withdrawalListTwoSets.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/PlatformTransfer',
				name:'PlatformTransfer',
				component: () => import('../views/transfer/PlatformTransfer.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remittance',
				name:'remittance',
				component: () => import('../views/report/remittance.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remittanceList',
				name:'remittanceList',
				component: () => import('../views/report/remittanceList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/dispute',
				name:'dispute',
				component: () => import('../views/report/dispute.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remList',
				name:'remList',
				component: () => import('../views/report/remList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/wildCardList',
				name:'wildCardList',
				component: () => import('../views/report/wildCardList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/foreignCurrency',
				component: () => import('../views/report/foreignCurrency.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/refundList',
				component: () => import('../views/report/refundList.vue'),
				meta: {
					keepAlive: true
				}
			},

			{
				path: '/home/drawbackList',
				component: () => import('../views/report/drawbackList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/secretKey',
				component: () => import('../views/report/secretKey.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/business',
				component: () => import('../views/report/business.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/electron',
				component: () => import('../views/report/electron.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/realname',
				component: () => import('../views/report/realname.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/steganogram',
				component: () => import('../views/system/steganogram.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/administratorsList',
				component: () => import('../views/system/administratorsList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/role',
				component: () => import('../views/system/role.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/bindingPhone',
				component: () => import('../views/system/bindingPhone.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/globalAcc',
				component: () => import('../views/system/globalAcc.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remittanceMonery',
				component: () => import('../views/system/remittanceMonery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/remittanceMoneryList',
				component: () => import('../views/system/remittanceMoneryList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/contributeMoney',
				component: () => import('../views/system/contributeMoney.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/payment',
				component: () => import('../views/system/payment.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/paymentBatch',
				component: () => import('../views/system/paymentBatch.vue'),
				meta: {
					keepAlive: true
				}
			},

			{
				path: '/home/paymentList',
				component: () => import('../views/system/paymentList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/paymentQuery',
				component: () => import('../views/system/paymentQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/crossBorder',
				component: () => import('../views/system/crossBorder.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/home/crossBorderList',
				component: () => import('../views/system/crossBorderList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/retrieveMoneryList',
				name: 'retrieveMoneryList',
				component: () => import('../views/system/retrieveMoneryList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/retrieveMoneryListCopy',
				name: 'retrieveMoneryListCopy',
				component: () => import('../views/system/retrieveMoneryListCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/myAccountList',
				name: 'myAccountList',
				component: () => import('../views/system/myAccountList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/myAccountListCopy',
				name: 'myAccountListCopy',
				component: () => import('../views/system/myAccountListCopy.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/addedServices',
				name:'addedServices',
				component: () => import('../views/system/addedService.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/companyRegister',
				name:'companyRegister',
				component: () => import('../views/system/companyRegister.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/companyRegisterDetail',
				name:'companyRegisterDetail',
				component: () => import('../views/system/companyRegisterDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/VATRegister',
				name:'VATRegister',
				component: () => import('../views/system/VATRegister.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/VATRegisterDetail',
				name: 'VATRegisterDetail',
				component: () => import('../views/system/VATRegisterDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopGuide',
				name:'shopGuide',
				component: () => import('../views/system/shopGuide.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/shopGuideDetail',
				name: 'shopGuideDetail',
				component: () => import('../views/system/shopGuideDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/independencyStation',
				name:'independencyStation',
				component: () => import('../views/system/independencyStation.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/independencyStationDetail',
				name: 'independencyStationDetail',
				component: () => import('../views/system/independencyStationDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceAddList',
				name:'serviceAddList',
				component: () => import('../views/system/serviceAddList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceCompany',
				name: 'serviceCompany',
				component: () => import('../views/addService/companyRegister.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceCompanyDetail',
				name: 'serviceCompanyDetail',
				component: () => import('../views/addService/companyRegisterDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceVAT',
				name: 'serviceVAT',
				component: () => import('../views/addService/VATRegister.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/myInsure',
				name: 'myInsure',
				component: () => import('../views/addService/myInsure.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/insureRecord',
				name: 'insureRecord',
				component: () => import('../views/addService/insureRecord.vue'),
				meta: {
					keepAlive: true
				}
			},

			{
				path: '/serviceVATDetail',
				name: 'serviceVATDetail',
				component: () => import('../views/addService/VATRegisterDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceIndependence',
				name: 'serviceIndependence',
				component: () => import('../views/addService/independencyStation.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceIndependenceDetail',
				name: 'serviceIndependenceDetail',
				component: () => import('../views/addService/independencyStationDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceGuide',
				name: 'serviceGuide',
				component: () => import('../views/addService/shopGuide.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceGuideDetail',
				name: 'serviceGuideDetail',
				component: () => import('../views/addService/shopGuideDetail.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceList',
				name: 'serviceList',
				component: () => import('../views/addService/serviceAddList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/rmbSubmit',
				name: 'rmbSubmit',
				component: () => import('../views/publicUse/rmbSubmit.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/quanSubmit',
				name: 'quanSubmit',
				component: () => import('../views/publicUse/quanSubmit.vue'),
				meta: {
					keepAlive: true
				}
			},
			// 贷款
			{
				path: '/loanApply',
				name: 'loanApply',
				component: () => import('../views/loan/loanApply.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/loanApplyConfirm',
				name: 'loanApplyConfirm',
				component: () => import('../views/loan/loanApplyConfirm.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/loanApplyList',
				name:'loanApplyList',
				component: () => import('../views/loan/loanApplyList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/wantLoanApply',
				name: 'wantLoanApply',
				component: () => import('../views/loan/wantLoanApply.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/loanApplySuccess',
				name: 'loanApplySuccess',
				component: () => import('../views/loan/loanApplySuccess.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/loanApplyEnd',
				name: 'loanApplyEnd',
				component: () => import('../views/loan/loanApplyEnd.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/LoanRecordQuery',
				name: 'LoanRecordQuery',
				component: () => import('../views/loan/LoanRecordQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/RepaymentRecordQuery',
				name: 'RepaymentRecordQuery',
				component: () => import('../views/loan/RepaymentRecordQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ImmediateRepayment',
				name: 'ImmediateRepayment',
				component: () => import('../views/loan/ImmediateRepayment.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/haiMaiList',
				name: 'haiMaiList',
				component: () => import('../views/haiMai/haiMaiList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/haiMaiApply',
				name: 'haiMaiApply',
				component: () => import('../views/haiMai/haiMaiApply.vue'),
				meta: {
					keepAlive: true
				}
			},
			// 小币种操作
			{
				path: '/currencyDollar',
				name: 'currencyDollar',
				component: () => import('../views/shopManag/currencyDollar.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/currencyDollarList',
				name: 'currencyDollarList',
				component: () => import('../views/shopManag/currencyDollarList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/SmallCurrencyCollectionApplication',
				name: 'SmallCurrencyCollectionApplication',
				component: () => import('../views/shopManag/SmallCurrencyCollectionApplication.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/SmallCurrencyCollectionApplicationList',
				name: 'SmallCurrencyCollectionApplicationList',
				component: () => import('../views/shopManag/SmallCurrencyCollectionApplicationList.vue'),
				meta: {
					keepAlive: true
				}
			},
			// 常见问题
			{
				path: '/commonProblem',
				name: 'commonProblem',
				component: () => import('../components/commonProblem.vue'),
				meta: {
					keepAlive: true
				}
			},
			//提现
			{
				path: '/withdraw',
				name: 'withdraw',
				component: () => import('../views/withdraw/withdraw.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/withdrawList',
				name: 'withdrawList',
				component: () => import('../views/withdraw/withdrawList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/CashWithdrawalAccount',
				name: 'CashWithdrawalAccount',
				component: () => import('../views/withdraw/CashWithdrawalAccount.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/WithdrawalAccountList',
				name: 'WithdrawalAccountList',
				component: () => import('../views/system/WithdrawalAccountList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/WithdrawalAccountAdd',
				name: 'WithdrawalAccountAdd',
				component: () => import('../views/system/WithdrawalAccountAdd.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/WithdrawalAccountLook',
				name: 'WithdrawalAccountLook',
				component: () => import('../views/system/WithdrawalAccountLook.vue'),
				meta: {
					keepAlive: true
				}
			},
			//账户设置与安全
			{
				path: '/accountSecurity',
				name: 'accountSecurity',
				component: () => import('../views/administrators/accountSecurity.vue'),
				meta: {
					keepAlive: true
				}
			},
			//收款订单查询
			{
				path: '/CollectionOrderList',
				name: 'CollectionOrderList',
				component: () => import('../views/shopManag/CollectionOrderList.vue'),
				meta: {
					keepAlive: true
				}
			},
			//海外仓
			{
				path: '/OverseasWarehouseService',
				name: 'OverseasWarehouseService',
				component: () => import('../views/OverseasWarehouse/OverseasWarehouseService.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/InventoryManagement',
				name: 'InventoryManagement',
				component: () => import('../views/OverseasWarehouse/InventoryManagement.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/InboundAndOutboundQuery',
				name: 'InboundAndOutboundQuery',
				component: () => import('../views/OverseasWarehouse/InboundAndOutboundQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/OrderManagement',
				name: 'OrderManagement',
				component: () => import('../views/OverseasWarehouse/OrderManagement.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/SignedMerchant',
				name: 'SignedMerchant',
				component: () => import('../views/OverseasWarehouse/SignedMerchant.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/InventoryRecordQuery',
				name: 'InventoryRecordQuery',
				component: () => import('../views/OverseasWarehouse/InventoryRecordQuery.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ArrivalWarehousing',
				name: 'ArrivalWarehousing',
				component: () => import('../views/OverseasWarehouse/ArrivalWarehousing.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ShippingManagement',
				name: 'ShippingManagement',
				component: () => import('../views/OverseasWarehouse/ShippingManagement.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/OrderManagementList',
				name: 'OrderManagementList',
				component: () => import('../views/OverseasWarehouse/OrderManagementList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/returnOrder',
				name: 'returnOrder',
				component: () => import('../views/OverseasWarehouse/returnOrder.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/serviceReturnOrder',
				name: 'serviceReturnOrder',
				component: () => import('../views/OverseasWarehouse/serviceReturnOrder.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ShippingOrderInquiry',
				name: 'ShippingOrderInquiry',
				component: () => import('../views/OverseasWarehouse/ShippingOrderInquiry.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/InventoryRecord',
				name: 'InventoryRecord',
				component: () => import('../views/OverseasWarehouse/InventoryRecord.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/InventoryRecordDetails',
				name: 'InventoryRecordDetails',
				component: () => import('../views/OverseasWarehouse/InventoryRecordDetails.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ServerInventoryRecord',
				name: 'ServerInventoryRecord',
				component: () => import('../views/OverseasWarehouse/ServerInventoryRecord.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/BillingInquiry',
				name: 'BillingInquiry',
				component: () => import('../views/OverseasWarehouse/BillingInquiry.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/HistoricalBillList',
				name: 'HistoricalBillList',
				component: () => import('../views/OverseasWarehouse/HistoricalBillList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ShipmentBatchManagement',
				name: 'ShipmentBatchManagement',
				component: () => import('../views/OverseasWarehouse/ShipmentBatchManagement.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/FulfillOrdersManually',
				name: 'FulfillOrdersManually',
				component: () => import('../views/OverseasWarehouse/FulfillOrdersManually.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/ServerInventoryRecordDetails',
				name: 'ServerInventoryRecordDetails',
				component: () => import('../views/OverseasWarehouse/ServerInventoryRecordDetails.vue'),
				meta: {
					keepAlive: true
				}
			},
			// 权限管理
			// 角色列表
			{
				path: '/RoleList',
				name: 'RoleList',
				component: () => import('../views/PermissionManagement/RoleList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/OperatorList',
				name: 'OperatorList',
				component: () => import('../views/PermissionManagement/OperatorList.vue'),
				meta: {
					keepAlive: true
				}
			},
			// 收款账户列表
			{
				path: '/CollectionAccountList',
				name: 'CollectionAccountList',
				component: () => import('../views/shopManag/CollectionAccountList.vue'),
				meta: {
					keepAlive: true
				}
			},
			// 营销活动
			{
				path: '/ActivitiesList',
				name: 'ActivitiesList',
				component: () => import('../views/market/ActivitiesList.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/RewardSubsidiary',
				name: 'RewardSubsidiary',
				component: () => import('../views/market/RewardSubsidiary.vue'),
				meta: {
					keepAlive: true
				}
			},
			{
				path: '/welfarehdh',
				name: 'welfarehdh',
				component: () => import('../components/welfarehdh.vue'),
				meta: {
					keepAlive: true
				}
			},
		],
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
});
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default router;
